export default {
  // title
  logs_error_title: '错误日志',
  logs_action_title: '操作日志',
  logs_protocol_title: '协议日志',

  logs_action_list_login_event: '登录事件',
  logs_action_list_customer_event: '客户事件',
  logs_action_list_device_operation_event: '设备操作事件',
  logs_action_list_device_command_event: '设备命令事件',
  logs_action_list_device_issue: '设备问题日志',
  logs_action_list_device_model: '设备模型日志',
  logs_action_list_site_event: '站点事件',
  logs_action_list_user_event: '用户事件',

  // order
  logs_error_order_field: [
    {
      value: 0,
      name: '默认',
    },
    {
      value: 1,
      name: '报错类型',
    },
    {
      value: 2,
      name: '报错状态',
    },
    {
      value: 3,
      name: '报错发生时间',
    },
    {
      value: 4,
      name: '创建时间',
    },
  ],
  logs_action_order_field: [
    {
      value: 0,
      name: '默认',
    },
    {
      value: 1,
      name: '操作类型',
    },
    {
      value: 2,
      name: '操作用户',
    },
    {
      value: 3,
      name: '操作时间',
    },
  ],
  logs_protocol_order_field: [
    {
      value: 0,
      name: '默认',
    },
    {
      value: 1,
      name: 'SN',
    },
    {
      value: 2,
      name: '交互类型',
    },
  ],
  logs_protocol_data_type: {
    0: '打开命令',
    1: '关闭命令',
    2: '数据接收',
    3: '数据发送',
  },
  logs_login_type: {
    0: '登录',
    1: '登出',
  },

  logs_logout_reason: {
    0: '授权失败, 被拒绝',
    1: '用户退出登录',
    2: '断网，超时',
    3: '强制重新登录',
  },

  // table
  logs_table_user: '用户',
  logs_table_user_id: '用户ID',
  logs_table_user_name: '用户名',
  logs_table_action_type: '操作类型',
  logs_table_action_data: '操作数据',
  logs_table_location: '地点',
  logs_table_ip: 'IP',
  logs_table_config_name: '配置名称',
  logs_table_params_data: '参数',
  logs_table_data: '数据',
  logs_table_time_start: '开始时间',
  logs_table_time_end: '结束时间',
  logs_table_time: '时间',
  logs_table_execute_time: '执行时间',
  logs_table_execute_start_time: '执行开始时间',
  logs_table_execute_end_time: '执行结束时间',
  logs_table_config_start_time: '配置开始时间',
  logs_table_config_end_time: '配置结束时间',
  logs_table_execute_end_result: '执行结果',
  logs_table_device_id: '设备ID',
  logs_table_message_name: '消息名字',
  logs_table_device_sn: '设备SN',
  logs_table_device_name: '设备名称',
  logs_table_issue_id: '问题ID',
  logs_table_device_model: '设备模型',
  logs_table_event_type: '事件类别',
  logs_table_customer_name: '客户名称',
  logs_table_login_time: '登录时间',
  logs_table_logout_time: '登出时间',
  logs_table_logout_reason: '登录原因',
  logs_table_success: '成功',
  logs_table_site_name: '站点名称',

  // form
  logs_order_type: '排序类型',
};
